import {
  Button,
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AddIcon, CancelIcon, DeleteIcon, EditIcon } from "src/components/icons/ActionIcons";
import { betoniLaskutusText, pumppuLaskutusText } from "src/components/js/statics1";
import { useUserData } from "src/context/userContext";
import { asiakas_asiakasLinks_delete, asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import PropTypes from "prop-types";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import AreYouSureButton from "src/components/buttons/AreYouSureButton/AreYouSureButton";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import AsiakasSelectorAutocomplete from "src/components/asiakas/list/AsiakasSelectorAutocomplete";
import { tarjous_create_new, tarjous_delete } from "src/data/tarjous/TarjousFunctions";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import { DeAttachIcon } from "src/components/icons/NavIcons";

export default function GridKeikkaEditor_SourceAsiakasSettings_TableRow({
  asiakasId,
  JSONData,
  asiakasAsiakasLinkId = 0,
  evenRowNum,
  onEditTarjousClick = () => {},
  onSaveTarjousClick = async () => {},
}) {
  const { user, token, ownerAsiakasId } = useUserData();
  const { reload, sourceAsiakasSettings, setSourceAsiakasSettings } = useContext(
    GridKeikka_NewKeikkaContext
  );
  const [data, setData] = useState([]);
  const [asiakas, setAsiakas] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [sourceAsiakasSetting, setSourceAsiakasSetting] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const asynk = async () => {
      try {
        setData(JSON.parse(JSONData));
        const asiakas = await asiakas_fetch(user, asiakasId, token);
        setAsiakas(asiakas.globalAsiakas);
        setSourceAsiakasSetting(
          sourceAsiakasSettings.find((item) => item.asiakasAsiakasLinkId === asiakasAsiakasLinkId)
        );
        setIsLoaded(true);
      } catch (e) {
        console.log(e);
      }
    };
    asynk();
  }, [asiakasId, JSONData]);

  useEffect(() => {
    if (!isLoaded) return;
    // get row data from sourceAsiakasSettings
    const row = sourceAsiakasSettings.find(
      (item) => item.asiakasAsiakasLinkId === asiakasAsiakasLinkId
    );
    row.asiakasAsiakasLinkJSON = JSON.stringify(data);
    setSourceAsiakasSettings(sourceAsiakasSettings);
  }, [data]);

  const handleDeleteClick = async () => {
    setIsLoading(true);
    const a = await asiakas_asiakasLinks_delete(asiakasAsiakasLinkId, token);
    if (!a) return false;
    await reload();
    await onSaveTarjousClick();
    setIsLoading(false);
    return true;
  };

  const handleCommentChange = (e) => {
    setSourceAsiakasSetting({ ...sourceAsiakasSetting, comment: e.target.value });
  };
  const handleCommentBlur = (e) => {
    // update value in sourceAsiakasSettings
    const newSourceAsiakasSettings = sourceAsiakasSettings.map((item) =>
      item.asiakasAsiakasLinkId === asiakasAsiakasLinkId
        ? { ...item, comment: e.target.value }
        : item
    );
    setSourceAsiakasSettings(newSourceAsiakasSettings);
  };

  if (!isLoaded)
    return (
      <TableRow>
        <TableCell colSpan={8}>
          <ProgressBar show height={2} />
        </TableCell>
      </TableRow>
    );

  const handleCreateTarjousClick = async () => {
    setIsLoading(true);
    const result = await tarjous_create_new(ownerAsiakasId, null, token, asiakasId);
    const newTarjousId = result?.data?.tarjousId;
    sourceAsiakasSetting.tarjousId = newTarjousId;
    setSourceAsiakasSetting({ ...sourceAsiakasSetting, tarjousId: newTarjousId });
    const newSourceAsiakasSettings = sourceAsiakasSettings.map((item) =>
      item.asiakasAsiakasLinkId === asiakasAsiakasLinkId
        ? { ...item, tarjousId: newTarjousId }
        : item
    );
    setSourceAsiakasSettings(newSourceAsiakasSettings);
    await onSaveTarjousClick();
    setIsLoading(false);
  };

  const handleEditTarjousClick = () => {
    onEditTarjousClick(sourceAsiakasSetting.tarjousId);
  };

  const handleSetBetoniAsiakas = (asiakas) => {
    data.defaultBetoniAsiakasId = asiakas.asiakasId;
    setData({ ...data, defaultBetoniAsiakasId: asiakas.asiakasId });
  };

  const handleSetPumppuAsiakas = (asiakas) => {
    data.defaultPumppuAsiakasId = asiakas.asiakasId;
    setData({ ...data, defaultPumppuAsiakasId: asiakas.asiakasId });
  };

  const handleDeleteTarjousClick = async () => {
    setIsLoading(true);
    const r = await tarjous_delete(sourceAsiakasSetting.tarjousId, token);
    if (r.success) {
      sourceAsiakasSetting.tarjousId = 0;
      setSourceAsiakasSetting({ ...sourceAsiakasSetting, tarjousId: 0 });
      const newSourceAsiakasSettings = sourceAsiakasSettings.map((item) =>
        item.asiakasAsiakasLinkId === asiakasAsiakasLinkId ? { ...item, tarjousId: 0 } : item
      );
      setSourceAsiakasSettings(newSourceAsiakasSettings);
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  };

  const handleDetachTarjousClick = async () => {
    setIsLoading(true);
    setSourceAsiakasSetting({ ...sourceAsiakasSetting, tarjousId: null });
    const newSourceAsiakasSettings = sourceAsiakasSettings.map((item) =>
      item.asiakasAsiakasLinkId === asiakasAsiakasLinkId ? { ...item, tarjousId: null } : item
    );
    setSourceAsiakasSettings(newSourceAsiakasSettings);
    await onSaveTarjousClick();
    setIsLoading(false);
  };

  return (
    <>
      {renderTableRow()}
      {renderSourceAsiakasSettingsTableRow()}
    </>
  );

  function renderTableRow() {
    return (
      <TableRow className={evenRowNum ? "harmaaTausta2" : "harmaaTausta0"}>
        <TableCell
          style={{
            fontSize: "1.15em",
          }}>
          <b>{asiakas.asiakasNimi}</b>
        </TableCell>
        <TableCell>
          <div style={{ minWidth: 200 }}>
            <AsiakasSelectorAutocomplete
              shrinkLabel={true}
              defaultAsiakasId={data.defaultBetoniAsiakasId || 0}
              ownerAsiakasId={ownerAsiakasId}
              label={"Oletus betonitoimittaja"}
              variant="standard"
              setAsiakas={handleSetBetoniAsiakas}
              height={13}
            />
          </div>
          <div style={{ minWidth: 200 }}>
            <AsiakasSelectorAutocomplete
              shrinkLabel={true}
              defaultAsiakasId={data.defaultPumppuAsiakasId || 0}
              ownerAsiakasId={ownerAsiakasId}
              label={"Oletus pumpputoimittaja"}
              variant="standard"
              setAsiakas={handleSetPumppuAsiakas}
              height={13}
            />
          </div>
        </TableCell>
        <TableCell>
          {!data.kaanteinenLaskutus && (
            <>
              {sourceAsiakasSetting.tarjousId > 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Tarjous {sourceAsiakasSetting.tarjousId}
                  <Tooltip disableInteractive title="Muokkaa tarjousta.">
                    <IconButton size="small" onClick={handleEditTarjousClick}>
                      <EditIcon fontSize="12px" />
                    </IconButton>
                  </Tooltip>
                  <AreYouSureButton
                    onClick={handleDeleteTarjousClick}
                    component="iconButton" // button (default), iconButton, menuItem, box
                    componentProps={{
                      size: "small",
                    }}
                    snackbarProps={{
                      title: "Poisto",
                      failMessage: "Poisto epäonnistui.",
                      doneMessage: "Tarjous poistettu.",
                      autoHideDuration: 2000, // default 2000
                    }}
                    toolTipProps={{
                      title: "Poista tarjous.",
                      placement: "bottom-end", // default bottom-end
                    }}
                    disabled={false}
                    isLoading={false} // default false
                    askAreYouSure={true} // default true (if false, the following props are ignored)
                    helpId="tarjouksenPoisto" // default null
                    dialogProps={{
                      title: "Tarjouksen poisto",
                      content: "Tämä poistaa tarjouksen ja kaikki sen asetuksen.",
                      acceptText: "KYLLÄ, POISTA TARJOUS!",
                      cancelText: "PERUUTA",
                      ConfirmIcon: <DeleteIcon />,
                      CancelIcon: <CancelIcon color="error" />,
                    }}>
                    <DeleteIcon fontSize="12px" />
                  </AreYouSureButton>
                  <Tooltip disableInteractive title="Irroita tarjous.">
                    <IconButton size="small" onClick={handleDetachTarjousClick}>
                      <DeAttachIcon fontSize="12px" />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={handleCreateTarjousClick}>
                  <AddIcon fontSize="12px" /> Luo tarjous
                </Button>
              )}
            </>
          )}
          {!data.kaanteinenLaskutus && sourceAsiakasSetting.tarjousId > 0 && (
            <div className="flex">
              <Checkbox
                checked={data.vainSourceAsiakasTarjous || false}
                onChange={(e) => setData({ ...data, vainSourceAsiakasTarjous: e.target.checked })}
              />
              <div>Laskututetaan vain tilauksen lähdettä</div>
              <div>
                <HelperIcon alignRight={false} helpId="laskutusVainTarjous" />
              </div>
            </div>
          )}
          {!sourceAsiakasSetting.tarjousId > 0 && (
            <div className="flex">
              <Checkbox
                checked={data.kaanteinenLaskutus || false}
                onChange={(e) => setData({ ...data, kaanteinenLaskutus: e.target.checked })}
              />
              Käänteinen laskutus
            </div>
          )}
        </TableCell>
        <TableCell style={{ opacity: 0.7 }}>
          <div className="flex">
            <Checkbox
              checked={data.isBetoniSuoraLaskutus}
              onChange={(e) => setData({ ...data, isBetoniSuoraLaskutus: e.target.checked })}
            />
            {betoniLaskutusText(
              "betonitoimittaja",
              "pumpputoimittaja",
              "asiakas",
              data.isBetoniSuoraLaskutus,
              data.isPumppuSuoraLaskutus
            )}
          </div>
          <div className="flex">
            <Checkbox
              checked={data.isPumppuSuoraLaskutus}
              onChange={(e) => setData({ ...data, isPumppuSuoraLaskutus: e.target.checked })}
            />
            {pumppuLaskutusText(
              "betonitoimittaja",
              "pumpputoimittaja",
              "asiakas",
              data.isBetoniSuoraLaskutus,
              data.isPumppuSuoraLaskutus
            )}
          </div>
        </TableCell>
        <TableCell>
          <AreYouSureButton
            onClick={handleDeleteClick}
            component="iconButton" // button (default), iconButton, menuItem, box
            //   componentProps={{
            //     fullWidth: true, // default false
            //     variant: "outlined", // default "contained"
            //     "aria-label": "",
            //     endIcon: <ArrowForwardIcon />, // for button component
            //   }}
            snackbarProps={{
              title: "Toiminto",
              failMessage: "Toiminto epäonnistui.",
              klikMessage: "Toiminto käynnistetty.",
              doneMessage: "Toiminto suoritettu.",
              autoHideDuration: 2000, // default 2000
            }}
            toolTipProps={{
              title: "Poista asiakas.",
              placement: "bottom-end", // default bottom-end
            }}
            disabled={asiakasAsiakasLinkId === 0}
            isLoading={false} // default false
            askAreYouSure={true} // default true (if false, the following props are ignored)
            helpId="lähdeAsiakkaanPoisto" // default null
            dialogProps={{
              title: "Lähdeasiakkaan poisto",
              content: "Tämä poistaa lähdeasiakkaan ja kaikki sen asetuksen.",
              acceptText: "KYLLÄ, POISTA ASIAKAS!",
              cancelText: "PERUUTA",
              ConfirmIcon: <DeleteIcon />,
              CancelIcon: <CancelIcon color="error" />,
            }}>
            <DeleteIcon />
          </AreYouSureButton>
        </TableCell>
      </TableRow>
    );
  }

  function renderSourceAsiakasSettingsTableRow() {
    return (
      <TableRow className={evenRowNum ? "harmaaTausta2" : "harmaaTausta0"}>
        <TableCell colSpan={5} style={{ paddingLeft: 50 }}>
          <ProgressBar show={isLoading} height={2} />
          <TextField
            value={sourceAsiakasSetting.comment}
            size="small"
            onChange={handleCommentChange}
            onBlur={handleCommentBlur}
            fullWidth
            variant="standard"
            label="selite"
          />
        </TableCell>
      </TableRow>
    );
  }
}

GridKeikkaEditor_SourceAsiakasSettings_TableRow.propTypes = {
  asiakasId: PropTypes.number,
  JSONData: PropTypes.string,
  asiakasAsiakasLinkId: PropTypes.number,
  evenRowNum: PropTypes.bool,
  onEditTarjousClick: PropTypes.func,
  onSaveTarjousClick: PropTypes.func,
};
